import {
    formatHistoryObjectLines,
    getHistoryVariantClass,
    parseRuleHistoryMessage,
    stripHistoryMessageHtml,
} from "../utils/ruleHistoryFormatter";

function ValueBlock({ title, lines, value, componentKey }) {
    let content = lines;
    if (!content?.length) {
        if (Array.isArray(value) && value.length === 1 && typeof value[0] === "object") {
            content = formatHistoryObjectLines(value[0], componentKey);
        } else if (value && typeof value === "object") {
            content = formatHistoryObjectLines(value, componentKey);
        } else if (value) {
            content = [String(value)];
        } else {
            content = ["—"];
        }
    }

    return (
        <div className="pp-rule-history-value-block">
            <div className="pp-rule-history-value-title">{title}</div>
            <ul className="pp-rule-history-value-list mb-0">
                {content.map((line, index) => (
                    <li key={`${title}-${index}`}>{line}</li>
                ))}
            </ul>
        </div>
    );
}

function HistoryChangeCard({ change }) {
    return (
        <div className="pp-rule-history-change">
            <div className="pp-rule-history-change-header">
                <span className={`badge ${getHistoryVariantClass(change.variant)}`}>
                    {change.label}
                </span>
                {change.componentLabel && (
                    <span className="pp-rule-history-change-title">{change.componentLabel}</span>
                )}
            </div>

            {change.fieldDiffs?.length > 0 && (
                <div className="pp-rule-history-diff-list">
                    {change.fieldDiffs.map((diff) => (
                        <div className="pp-rule-history-diff-row" key={diff.path}>
                            <div className="pp-rule-history-diff-label">{diff.path}</div>
                            <div className="pp-rule-history-diff-values">
                                <span className="pp-rule-history-diff-before">{diff.before}</span>
                                <i className="fas fa-arrow-right pp-rule-history-diff-arrow" aria-hidden="true" />
                                <span className="pp-rule-history-diff-after">{diff.after}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {change.fieldDiffs?.length === 0 && change.beforeValue !== undefined && change.afterValue !== undefined && (
                <div className="pp-rule-history-compare">
                    <ValueBlock title="Vorher" value={change.beforeValue} componentKey={change.componentKey} />
                    <ValueBlock title="Nachher" value={change.afterValue} componentKey={change.componentKey} />
                </div>
            )}

            {change.before !== undefined && change.after !== undefined && !change.fieldDiffs && (
                <div className="pp-rule-history-inline-diff">
                    <span className="pp-rule-history-diff-before">{change.before || "—"}</span>
                    <i className="fas fa-arrow-right pp-rule-history-diff-arrow" aria-hidden="true" />
                    <span className="pp-rule-history-diff-after">{change.after || "—"}</span>
                </div>
            )}

            {change.lines?.length > 0 && (
                <ul className="pp-rule-history-value-list mb-0 mt-2">
                    {change.lines.map((line, index) => (
                        <li key={`line-${index}`}>{line}</li>
                    ))}
                </ul>
            )}

            {change.text && !change.before && change.after === undefined && !change.lines?.length && (
                <div className="pp-rule-history-text">{change.text}</div>
            )}
        </div>
    );
}

export default function RuleHistoryMessageView({ message }) {
    const changes = parseRuleHistoryMessage(message);

    if (!changes.length) {
        const fallback = stripHistoryMessageHtml(message);
        if (fallback) {
            return <div className="pp-rule-history-text">{fallback}</div>;
        }
        return <span className="text-muted">—</span>;
    }

    return (
        <div className="pp-rule-history-message">
            {changes.map((change, index) => (
                <HistoryChangeCard
                    key={`${change.typeKey}-${change.componentKey || change.label}-${index}`}
                    change={change}
                />
            ))}
        </div>
    );
}
